import { render, staticRenderFns } from "./forms-of-payment-server-side.vue?vue&type=template&id=215b5958"
import script from "./forms-of-payment-server-side.vue?vue&type=script&lang=js"
export * from "./forms-of-payment-server-side.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports